import { useApiErrorToast } from 'app/api/app-api/apiHooksHelpers';
import { useEffect } from 'react';
import { Button, Heading, Modal, ModalActions, ModalContent, ModalHeader, ModalLayout, useToasts } from 'tombac';
import { CommunicationMessage } from "./CommunicationMessage";
import { useDeleteCommunicationMutation } from "./communicationsApiHooks";
import { useCommunicationDate } from "./helpers/useCommunicationDate";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DeleteCommunicationModal = _ref => {
  let {
    communicationItem,
    onSuccess,
    ...modalProps
  } = _ref;
  const {
    addToast
  } = useToasts();
  const addApiErrorToast = useApiErrorToast();
  const {
    error,
    mutateAsync: deleteCommunication,
    ...deleteMutation
  } = useDeleteCommunicationMutation();
  useEffect(() => {
    if (error) addApiErrorToast(error);
  }, [error, addApiErrorToast]);
  const date = useCommunicationDate(communicationItem?.date);
  if (!communicationItem) {
    return null;
  }
  const handleDelete = async () => {
    await deleteCommunication({
      communicationItemId: communicationItem.id
    });
    addToast('Communication deleted successfully', 'success');
    onSuccess();
  };
  return /*#__PURE__*/_jsx(Modal, {
    ...modalProps,
    "data-sentry-element": "Modal",
    "data-sentry-component": "DeleteCommunicationModal",
    "data-sentry-source-file": "DeleteCommunicationModal.tsx",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      size: "l",
      "data-sentry-element": "ModalLayout",
      "data-sentry-source-file": "DeleteCommunicationModal.tsx",
      "data-sentry-element": "ModalLayout",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        "data-sentry-element": "ModalHeader",
        "data-sentry-source-file": "DeleteCommunicationModal.tsx",
        "data-sentry-element": "ModalHeader",
        children: "Are you sure you want to delete this communication?"
      }), /*#__PURE__*/_jsxs(ModalContent, {
        variant: "scrollable",
        "data-sentry-element": "ModalContent",
        "data-sentry-source-file": "DeleteCommunicationModal.tsx",
        "data-sentry-element": "ModalContent",
        children: [/*#__PURE__*/_jsx(Heading, {
          $mb: "2sp",
          as: "h2",
          level: 4,
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "DeleteCommunicationModal.tsx",
          "data-sentry-element": "Heading",
          children: date
        }), /*#__PURE__*/_jsx(CommunicationMessage, {
          communicationItem: communicationItem,
          "data-sentry-element": "CommunicationMessage",
          "data-sentry-source-file": "DeleteCommunicationModal.tsx",
          "data-sentry-element": "CommunicationMessage"
        })]
      }), /*#__PURE__*/_jsxs(ModalActions, {
        "data-sentry-element": "ModalActions",
        "data-sentry-source-file": "DeleteCommunicationModal.tsx",
        "data-sentry-element": "ModalActions",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: modalProps.onRequestClose,
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "DeleteCommunicationModal.tsx",
          "data-sentry-element": "Button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          busy: deleteMutation.isLoading,
          onClick: handleDelete,
          variant: "danger",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "DeleteCommunicationModal.tsx",
          "data-sentry-element": "Button",
          children: "Delete"
        })]
      })]
    })
  });
};